import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ShellLayoutComponent } from "./theme/components/layout/shell-layout.component";
import { AuthGuard } from "./core/authentication.guard";
import { LoginLayoutComponent } from "./theme/components/layout/login-layout/login-layout.component";
import { PaddedLayoutComponent } from "./theme/components/layout/padded-layout/padded-layout.component";
import { AuthResolver } from "./auth.resolver";
import { CommunityLayoutComponent } from "./pages/communities/community/community-layout/community-layout.component";
import { CommunityResolver } from "./pages/communities/community/community.resolver";
import { EventResolver } from "./pages/events/event/event.resolver";

const routes: Routes = [
  {
    path: "",
    canActivate: [AuthGuard],
    resolve: { authorize: AuthResolver },
    component: ShellLayoutComponent,
    children: [
      {
        path: "",
        component: PaddedLayoutComponent,
        children: [
          {
            path: "",
            loadChildren: () =>
              import("./pages/dashboard/dashboard.module").then(
                (m) => m.DashboardModule
              ),
          },
          {
            path: "profile/:id",
            loadChildren: () =>
              import("./pages/profile/profile.module").then(
                (m) => m.ProfileModule
              ),
          },
          {
            path: "post/:id",
            loadChildren: () =>
              import("./pages/single-post/single-post.module").then(
                (m) => m.SinglePostModule
              ),
          },
          {
            path: "notifications",
            loadChildren: () =>
              import("./pages/notifications/notifications.module").then(
                (m) => m.NotificationsModule
              ),
          },
          {
            path: "communities",
            loadChildren: () =>
              import("./pages/communities/communities.module").then(
                (m) => m.CommunitiesModule
              ),
          },
          {
            path: "community/:id",
            component: CommunityLayoutComponent,
            resolve: { community: CommunityResolver },
            children: [
              {
                path: "",
                loadChildren: () =>
                  import("./pages/communities/community/community.module").then(
                    (m) => m.CommunityModule
                  ),
              },
            ],
          },
          {
            path: "events",
            loadChildren: () =>
              import("./pages/events/events.module").then(
                (m) => m.EventsModule
              ),
          },
          {
            path: "event/:id",
            resolve: { event: EventResolver },
            children: [
              {
                path: "",
                loadChildren: () =>
                  import("./pages/events/event/event.module").then(
                    (m) => m.EventModule
                  ),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "token-login",
    loadChildren: () =>
      import("./pages/token-login/token-login.module").then((m) => m.TokenLoginModule),
  },
  {
    path: "",
    component: LoginLayoutComponent,
    children: [
      {
        path: "login",
        loadChildren: () =>
          import("./pages/login/login.module").then((m) => m.LoginModule),
      },
      {
        path: "forgot-password",
        loadChildren: () =>
          import("./pages/login/forgot-password/forgot-password.module").then(
            (m) => m.ForgotPasswordModule
          ),
      },
      {
        path: "register",
        loadChildren: () =>
          import("./pages/login/register/register.module").then(
            (m) => m.RegisterModule
          ),
      },
    ],
  },
  { path: "", canActivate: [AuthGuard], redirectTo: "", pathMatch: "full" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
